<template>
  <div id="PageHeader">
    <div class="pagetop  wow bounceInRight">
      <div class="pagetop-title">
        {{title.toUpperCase()}}
      </div>
      <div class="pagetop-rgith">
      <!-- Home > -->
        <i class="fa fa-map-marker-alt me-3"></i>{{$t('my.currentL')}}:  {{title}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PageHeader",
    data() {
      return {
      };
    },
    props: {
      typelist:String,
      title:String
    },
  };
</script>

<style>
  .pagetop{
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
  }
  .pagetop-title{
    padding-left: 10px;
    font-size: 30px;
    font-weight: bold;
    line-height: 35px;
    border-left: 8px solid #0c74b5;
  }
  .pagetop-rgith{
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue